import * as TT from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';

export const TooltipProvider = TT.Provider;

/** Small hover/focus hint. Use for law codes and icon-only buttons; never for essential info. */
export function Tooltip({ content, children, side = 'top' }: { content: ReactNode; children: ReactNode; side?: 'top' | 'right' | 'bottom' | 'left' }) {
  return (
    <TT.Root delayDuration={250}>
      <TT.Trigger asChild>{children}</TT.Trigger>
      <TT.Portal>
        <TT.Content side={side} sideOffset={6}
          className="z-50 max-w-xs rounded-md bg-slate-900 px-2.5 py-1.5 text-xs text-white shadow-pop animate-fade-in dark:bg-slate-100 dark:text-slate-900">
          {content}
        </TT.Content>
      </TT.Portal>
    </TT.Root>
  );
}
